var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIOsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0918 4.25545C19.1454 3.12752 19.8581 1.56155 19.663 0C18.1452 0.0541679 16.3056 0.890985 15.2161 2.01881C14.2394 3.01727 13.3843 4.61301 13.6125 6.14393C15.3062 6.25851 17.0365 5.38154 18.0918 4.25545ZM21.3243 15.0396C21.292 11.5387 24.096 9.85731 24.2202 9.77606C22.6438 7.39872 20.1886 7.07342 19.3143 7.03674C17.2237 6.81728 15.238 8.30277 14.1767 8.30277C13.1196 8.30277 11.4846 7.06555 9.75076 7.09878C7.47139 7.13633 5.37113 8.46364 4.20047 10.5673C1.83264 14.7992 3.59358 21.0681 5.9009 24.5008C7.02882 26.1812 8.37178 28.0664 10.1353 27.9982C11.8377 27.93 12.4794 26.8659 14.5333 26.8659C16.588 26.8659 17.1633 27.9982 18.9609 27.9641C20.7901 27.93 21.9477 26.2513 23.066 24.5655C24.36 22.6166 24.8934 20.7298 24.9239 20.6345C24.8846 20.6117 21.3619 19.226 21.3243 15.0396Z",
    fill: "#B7B7B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIOsIcon);
export default __webpack_public_path__ + "static/media/iOSIcon.3d2eb48079324681c29d25341139ff09.svg";
export { ForwardRef as ReactComponent };